var exports = {
  "kL": "x04b3a21e--f122ba--container",
  "DD": "x04b3a21e--f122ba--title",
  "h_": "x04b3a21e--f122ba--description",
  "io": "x04b3a21e--f122ba--open-village-logo",
  "nf": "x04b3a21e--f122ba--link",
};

module.exports = exports;
